// PingZeAssess.js

import React, { useState } from 'react';
import axios from 'axios';
import Assessstyles from './Assess.module.css';
import Header from './Header';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

function PingZeAssess() {
  const [submissionType, setSubmissionType] = useState('');
  const [submissionText, setSubmissionText] = useState('');
  const [pingZeFeedback, setPingZeFeedback] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(null);

  const handleSubmit = async () => {
    if (!submissionType || !submissionText.trim()) {
      setError('Please complete all steps before submitting.');
      return;
    }

    setLoading(true);
    setPingZeFeedback('');
    setError(null);
    setIsValid(null);

    let endpoint = '';
    let payload = {};

    if (submissionType === 'couplet') {
      endpoint = '/assess-couplet';
      payload = {
        couplet: submissionText.trim(),
        user_level: 'guest',
        level: 'juren',
      };
    } else if (submissionType === 'poem') {
      endpoint = '/assess-poem';
      payload = {
        poem: submissionText.trim(),
        user_level: 'guest',
        level: 'gongshi',
      };
    }

    try {
      const response = await axios.post(`${API_URL}${endpoint}`, payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      setIsValid(response.data.is_valid);
      setPingZeFeedback(response.data.ping_ze_feedback || '');
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while processing your submission.');
    }
    setLoading(false);
  };

  const handleReset = () => {
    setSubmissionText('');
    setSubmissionType('');
    setPingZeFeedback('');
    setError(null);
    setLoading(false);
    setIsValid(null);
  };

  return (
    <div>
      <Header />
      <div className={Assessstyles.assessContainer}>
        <h1 className={Assessstyles.title}>Ping/Ze Pattern Assessment</h1>
        <p className={Assessstyles.instructions}>
          Choose a form and submit your couplet or poem to check its Ping/Ze pattern.
        </p>

        <div className={Assessstyles.step}>
          <h4>Select Submission Type</h4>
          <select
            value={submissionType}
            onChange={(e) => setSubmissionType(e.target.value)}
            className={Assessstyles.dropdown}
          >
            <option value="">Choose Submission Type...</option>
            <option value="couplet">Couplet</option>
            <option value="poem">Poem</option>
          </select>
          {!submissionType && <p className={Assessstyles.error}>Submission Type is required.</p>}
        </div>

        {submissionType && (
          <div className={Assessstyles.step}>
            <h3>Enter {submissionType === 'couplet' ? 'Couplet' : 'Poem'}</h3>
            <p className={Assessstyles.textInstructions}>
              Please enter a {submissionType}. Do not include punctuation.
            </p>
            <textarea
              placeholder={`Enter your ${submissionType} here...`}
              value={submissionText}
              onChange={(e) => setSubmissionText(e.target.value)}
              className={Assessstyles.largeTextArea}
              rows="8"
            />
          </div>
        )}

        <div className={Assessstyles.buttonContainer}>
          <button
            onClick={handleSubmit}
            disabled={!submissionType || loading}
            className={Assessstyles.button}
          >
            {loading ? 'Checking...' : 'Check Ping/Ze'}
          </button>
          <button
            onClick={handleReset}
            className={`${Assessstyles.button} ${Assessstyles.resetButton}`}
          >
            Clear
          </button>
        </div>

        {error && <div className={Assessstyles.error}>{error}</div>}

        {pingZeFeedback && (
          <div className={Assessstyles.pingZeFeedback}>
            <h2>Ping/Ze Feedback</h2>
            {pingZeFeedback.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PingZeAssess;

